import { programs } from '../config/programs';

const livePrograms = programs.filter((program) => program.live === true);

// create a unique-value array
const posaList = [...new Set(livePrograms.map((program) => program.posa))];

export default posaList;
